import { Enrolment } from '@/models/enrolment';
import { CsvExport } from './csv-export';

export class ClientReviewCsvExport extends CsvExport {
	public constructor() {
		super('All the enrolments that are ready to be reviewed by this client');
	}

	protected findExportableEnrolments(enrolments: Enrolment[]): Enrolment[] {
		return enrolments.filter((_) => _.isReadyToShareWithClient() || _.isAwaitingReview() || _.isPendingConfirmationReview());
	}

	protected determineEmptyExportFileName(): string {
		return 'Empty client review export';
	}

	protected determineExportFileNameFromEnrolment(enrolment: Enrolment): string {
		return `Enrolments to be reviewed by ${enrolment.organisationName}`;
	}

	protected createHeaderCells(): string[] {
		return [
			'Student email address',
			'Student name',
			'Degree level',
			'Nationality',
			'Source',
			'Intake month',
			'Intake year',
			'Review status',
			'Success fee category',
			'Tuition fee value',
			'Tuition fee currency',
			'Notes'
		];
	}

	protected createEnrolmentLineCells(enrolment: Enrolment): string[] {
		return [
			enrolment.studentEmail ? enrolment.studentEmail : '',
			enrolment.studentName,
			enrolment.programmeLevel ? enrolment.programmeLevel.name : '',
			enrolment.studentNationality ? enrolment.studentNationality.name : '',
			enrolment.clientSourceName,
			enrolment.intakeMonth ? enrolment.intakeMonth.name : '',
			enrolment.intakeYear ? enrolment.intakeYear.toString() : '',
			this.determineReviewStatus(enrolment),
			enrolment.successFeeText,
			enrolment.tuitionFee ? enrolment.tuitionFee.toString() : '',
			enrolment.tuitionFeeCurrency ? enrolment.tuitionFeeCurrency.isoCode : '',
			enrolment.confirmationNotes
		];
	}

	private determineReviewStatus(enrolment: Enrolment): string {
		if (enrolment.isAwaitingReview() || enrolment.isReadyToShareWithClient()) {
			return '';
		}

		return enrolment.status.clientFacingName;
	}
}
